import Axios from "axios";

export default function handleAnnounce(c_id){
   // console.log(counsellingYear);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'handleAnnounce',  
            c_id      
          
        }
    });
    return response;
}